/*
import React, { createContext, useState, useEffect } from "react";
import { getCookie } from "../components/LoginModal";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const raw = getCookie("wal_user");
    if (raw) try { setUser(JSON.parse(raw)); } catch {}
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
*/
import React, { createContext, useContext, useEffect, useState } from "react";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => {
    try { return JSON.parse(localStorage.getItem("wal_auth") || "null"); }
    catch { return null; }
  });

  useEffect(() => {
    if (auth) localStorage.setItem("wal_auth", JSON.stringify(auth));
    else localStorage.removeItem("wal_auth");
  }, [auth]);

  const value = {
    user:  auth?.user  || null,
    token: auth?.token || null,
    setAuth,
    setUser: (u) => setAuth(prev => ({ ...(prev || {}), user: u })),
    signOut: () => setAuth(null),
  };

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be used within <AuthProvider>");
  return ctx;
}